// extracted by mini-css-extract-plugin
export default {"chooseFromMediaParent":"ChooseFromMedia_chooseFromMediaParent__uf9KI","loadingSpinnerParent":"ChooseFromMedia_loadingSpinnerParent__qZv3A"};